import { DONATION_INFO_GET_ROUTE } from "constants/constants";
import { fetcher } from "functions/fetcher";
import useSWR from "swr";
import st_dn from "./DonateNow.module.css";

const DonationInfo = () => {
  const { data: donationInfo } = useSWR(DONATION_INFO_GET_ROUTE, fetcher);

  const keyToUIMap = new Map([
    ["numberOfDonations", "Number of Donations"],
    ["largestDonationUsd", "Largest Donation"],
    ["totalUsd", "Total Donated"],
  ]);

  return (
    <section className={st_dn.donation_info_container}>
      <div className={st_dn.donation_info}>
        {donationInfo &&
          Object.keys(donationInfo).map((key: any, i: number) => {
            return (
              <div className={st_dn.info} key={i}>
                <h4>{keyToUIMap.get(key)}</h4>
                <h1>
                  {parseFloat(donationInfo[key]).toLocaleString() +
                    (key !== "numberOfDonations" ? " UST" : "")}
                </h1>
              </div>
            );
          })}
      </div>
    </section>
  );
};

export default DonationInfo;